/**
 * Helvetica's advance widths for ' ' through '~', in thousandths of an em.
 *
 * These are the standard Adobe AFM metrics, which is what `@react-pdf` draws
 * Helvetica with: `scripts/measurePages/printedName.measure.js` compares every one
 * of them with the renderer's own font and fails if they ever differ.
 */
const HELVETICA_WIDTHS = [
  278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278,
  556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556,
  1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778,
  667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556,
  333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556,
  556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584,
];

/** A character outside the table counts as a full em, the widest Helvetica has bar '@'. */
const FALLBACK_WIDTH = 1000;

/** í, ì, î and ï, which Helvetica draws on a dotless i. */
const DOTLESS_I_WIDTH = 278;

/**
 * How wide `text` is in Helvetica at `size`, in points.
 *
 * An accented letter is measured as its base letter - é is as wide as e in
 * Helvetica's metrics - except an accented i, which is drawn on a dotless ı
 * and is wider than i. Anything else outside ASCII counts as a full em, so the
 * estimate errs wide rather than narrow. That is the safe direction for its one
 * caller: the printed-name box in `DocumentHeader` is sized from this, and a
 * box narrower than its text would put an ellipsis on a name that fits.
 */
export function helveticaWidth(text: string, size: number): number {
  let width = 0;
  for (const character of text) {
    const base = character.normalize('NFD')[0];
    const code = base.charCodeAt(0);
    if (base === 'i' && character !== 'i') {
      width += DOTLESS_I_WIDTH;
    } else {
      width += code >= 32 && code < 127 ? HELVETICA_WIDTHS[code - 32] : FALLBACK_WIDTH;
    }
  }
  return (width * size) / 1000;
}
